module.exports = __webpack_public_path__ + "img/end2end_logo.3c2b4d8e.png";